import React from 'react';

import * as SS from '../TripHotelDetails/TripsHotelDetails.styles';

const ImportantInfo = ({policiesInfo}) => {
  const {showPolicy, policy = []} = policiesInfo;
  if (!showPolicy || !policy.length) {
    return null;
  }

  return(
    <SS.TripHotelDetailMainWrap>
      <SS.TripHotelDetailHeaderWrap>
        <SS.TripHotelHeaderText>MUST READ POLICIES</SS.TripHotelHeaderText>
        <SS.TripHotelHeaderSubText>Cancellation and Hotel policies</SS.TripHotelHeaderSubText>
      </SS.TripHotelDetailHeaderWrap>
      <SS.TripHotelInfoWrap>
        {policy.map((item, i) => 
          <li key={`info${i}`}>{item}</li>
        )}
      </SS.TripHotelInfoWrap>
    </SS.TripHotelDetailMainWrap>
  );
}

export default ImportantInfo;